<template>
  <v-container class="page">

    <div class="flex-container">
      <div class="flex-smallitem">
        <h4>
          VI. Informacje i spostrzeżenia wychowawcy wypoczynku dotyczące
          uczestnika wypoczynku
        </h4>
        <p>...........................................................................................................................</p>
        <p>...........................................................................................................................</p>
        <p>...........................................................................................................................</p>
        <p>...........................................................................................................................</p>
        <p>...........................................................................................................................</p>
          <div class="flex-container">
            <div class="flex-item">
              .........................................
            </div>
            <div class="flex-item">
              .........................................
            </div>
          </div>
          <div class="flex-container" style="margin-top: 10px;">
            <div class="flex-item" style="margin-left: 42px;">
              (miejscowość, data)
            </div>
            <div class="flex-item" style="margin-left: 20px;">
              (podpis wychowawcy wypoczynku)
            </div>
          </div>
      </div>

      <div class="flex-bigitem">
            <div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
          <div class="left-cointainer">
            <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg" />
          </div>
       </div>

        <h2 id="header">Karta kwalifikacyjna uczestnika wypoczynku</h2>

        <h4>I. Informacje dotyczące wypoczynku</h4>

        <ol>
          <li>
            Forma wypoczynku /właściwe zaznaczyć znakiem "X"/
            <ul style="list-style-type: none;">
              <li><input type="checkbox" /> kolonia</li>
              <li><input type="checkbox" /> biwak</li>
              <li><input type="checkbox" /> zimowiska</li>
              <li><input type="checkbox" /> półkolonia</li>
              <li><input type="checkbox" /> obóz</li>
              <li><input type="checkbox" /> inna forma wypoczynku: .........................</li>
              <li style="margin-left: 150px;">(proszę podać formę)</li>
            </ul>
          </li>
          <li>Termin wypoczynku: {{ termin }}</li>

          <li>
            Adres wypoczynku, miejsce lokalizacji wypoczynku:
            </li>
            </ol>
            {{ ubezpieczenie }}
            Trasa wypoczynku o charakterze wędrownym:
            <p>
              ..............................................................................................................
            </p>
            <p>Nazwa kraju w przypadku wypoczynku organizowanego za granicą: ............................</p>
          <div class="flex-container">
            <div class="flex-item">
              ......................................................
            </div>
            <div class="flex-item">
              ......................................................................
            </div>
          </div>
          <div class="flex-container" style="margin-top: 5px;">
            <div class="flex-item" style="margin-left: 46px;">
              (miejscowość, data)
            </div>
            <div class="flex-item" style="margin-left: 60px;">
              (podpis organizatora wypoczynku)
            </div>
          </div>

        <h4>II. Informacje dotyczące uczestnika wypoczynku</h4>

        <ol>
          <li>Imię (imiona) i nazwisko: {{ imieNazwisko }}</li>
          <li>Imiona i nazwiska rodziców: {{ NrUmowy }}</li>
          <li>Rok urodzenia: {{ dataUrodzenia }}</li>
          <li>Adres zamieszkania: {{ adres }}</li>
          <li>
            Adres zamieszkania lub pobytu rodziców (w przypadku uczestnika
            niepełnosprawnego): {{ adres }}
          </li>
          <li>Numer telefonu rodziców lub numer telefonu osoby wskazanej przez
          pełnoletniego uczestnika wypoczynku, w czasie trwania wypoczynku:
          {{ telefon }}</li>
        </ol>
      </div>
    </div>
    <div style="page-break-before: always;">
      </div>
    <div class="flex-container">
      <div class="flex-smallitem">
      <p>
        7. Informacja o specjalnych potrzebach edukacyjnych uczestnika wypoczynku,
        w szczególności o potrzebach wynikających z niepełnosprawności,
        niedostosowania społecznego lub zagrożenia niedostosowaniem społecznym
        {{ adreskor }}
      </p>
      <p>
        8. Istotne dane o stanie zdrowia uczestnika wypoczynku, rozwoju
        psychofizycznym i stosowanej diecie (np. na co uczestnik jest uczulony,
        jak znosi jazdę samochodem, czy przyjmuje stale leki i w jakich dawkach,
        czy nosi aparat ortodontyczny lub okulary)
        {{ emeryt }}, o szczepieniach ochronnych (wraz z podaniem roku lub
        przedstawienie książeczki zdrowia z aktualnym wpisem szczepień): tężec
        {{ rencista }} błonica {{ niepełnosprawność }} dur {{ stopień }} inne
        {{ student }} oraz numer PESEL uczestnika wypoczynku {{ pesel }}
      </p>

      <p style="font-weight: bold;">
        Wyrażam zgodę na przetwarzanie danych osobowych zawartych w karcie
        kwalifikacyjnej na potrzeby niezbędne do zapewnienia bezpieczeństwa i
        ochrony zdrowia uczestnika wypoczynku (zgodnie z ustawą z dnia 29 sierpnia
        1997 r. o ochronie danych osobowych (Dz. U. z 2015 r. poz. 2135, z późn.
        zm.)).
      </p>

         <div class="flex-container">
            <div class="flex-item">
              {{ubezpieczenieChorobowe}}
            </div>
            <div class="flex-item">
              {{NrUmowy}}
            </div>
          </div>
          <div class="flex-container" style="margin-top: 15px;">
            <div class="flex-item">
              .............................
            </div>
            <div class="flex-item">
              .....................................................
            </div>
          </div>
           <div class="flex-container">
            <div class="flex-item" style="margin-left: 70px;">
              (data)
            </div>
            <div class="flex-item">
              (podpis rodziców/pełnoletniego uczestnika wypoczynku)
            </div>
          </div>
           <div class="flex-container" style="margin-top: 15px;">
            <div class="flex-item">
              .............................
            </div>
            <div class="flex-item">
              .....................................................
            </div>
          </div>
          <div class="flex-container">
            <div class="flex-item" style="margin-left: 37px;">
              (data)
            </div>
            <div class="flex-item">
              (podpis lekarza, matki, ojca lub opiekuna)
            </div>
          </div>

      </div>

      <div class="flex-bigitem">
          <h4>
            III. Decyzja organizatora wypoczynku o zakwalifikowaniu uczestnika
            wypoczynku do udziału w wypoczynku
          </h4>

          <p>Postanawia się /właściwe zaznaczyć znakiem/:
            <ul style="list-style-type: none;">
          <li><input type="checkbox" /> zakwalifikować i skierować uczestnika na wypoczynek</li>
          <li><input type="checkbox" /> odmówić skierowania uczestnika na wypoczynek ze względu</li>
          </ul>
          ........................................................................................................................
          </p>
          <p>
          ........................................................................................................................
          </p>

          <div class="flex-container">
            <div class="flex-item">
              ................................
            </div>
            <div class="flex-item">
              ...................................................
            </div>
          </div>
          <div class="flex-container" style="margin-top: 10px;">
            <div class="flex-item" style="margin-left: 42px;">
              (data)
            </div>
            <div class="flex-item" style="margin-left: 20px;">
              (podpis organizatora wypoczynku)
            </div>
          </div>

          <h4 style="margin-top: 15px;">
            IV. Potwierdzenie przez kierownika wypoczynku pobytu uczestnika wypoczynku w miejscu wypoczynku
          </h4>

          <p>Uczestnik przebywał (adres miejsca wypoczynku) ..............................
            od dnia /dzień,miesiąc,rok/ ........................ do dnia /dzień,miesiąc,rok/ ........................
          </p>

          <div class="flex-container">
            <div class="flex-item">
              ................................
            </div>
            <div class="flex-item">
              ...................................................
            </div>
          </div>
          <div class="flex-container" style="margin-top: 10px;">
            <div class="flex-item" style="margin-left: 42px;">
              (data)
            </div>
            <div class="flex-item" style="margin-left: 20px;">
              (podpis kierownika wypoczynku)
            </div>
          </div>

          <h4 style="margin-top: 15px;">
            V. Informacja kierownika wypoczynku o stanie zdrowia uczestnika wypoczynku w czasie trwania wypoczynku oraz o chorobach przebytych w jego trakcie
          </h4>

          <p>...........................................................................................................................</p>
          <p>...........................................................................................................................</p>
          <p>...........................................................................................................................</p>

          <div class="flex-container">
            <div class="flex-item">
              .........................................
            </div>
            <div class="flex-item">
              ...................................................
            </div>
          </div>
          <div class="flex-container" style="margin-top: 10px;">
            <div class="flex-item" style="margin-left: 20px;">
              (miejscowość, data)
            </div>
            <div class="flex-item" style="margin-left: 20px;">
              (podpis kierownika wypoczynku)
            </div>
          </div>

        </div>
    </div>
  </v-container>
</template>

<script>
import UmowaMonitoring from './UmowaMonitoring';

export default {
  name: 'UmowaGitara',
  components: {
    UmowaMonitoring
  },
  props: {},
  data () {
    return {
      termin: '',
      ubezpieczenie: '',
      imieNazwisko: '',
      NrUmowy: '',
      dataUrodzenia: '',
      adres: '',
      telefon: '',
      adreskor: '',
      emeryt: '',
      rencista: '',
      niepełnosprawność: '',
      stopień: '',
      student: '',
      pesel: ''
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(([key, value]) => {
      this[key] = value
    })
  },
  methods: {},
  mounted() {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const currentURL = window.location.href;
          history.replaceState(history.state, "", "/");
          window.print();
          history.replaceState(history.state, "", currentURL);
        }, 300);
      });
  }
};
</script>

<style scoped>
.page-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: nowrap;
}
.flex-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    flex-wrap: nowrap;
    column-gap: 20px;
}
.flex-bigitem {
  flex-grow: 2;
}
.flex-smallitem {
  flex-grow: 1;
}
.flex-item {
  background: tomato;
}
.row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}
#header {
    text-transform: uppercase;
    text-decoration: underline;
    margin-bottom: 20px;
    text-align: center;
}
h4 {
    text-transform: uppercase;
}
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
  margin: 0px;
}
table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
}
th, td {
  border: 1px;
  border-collapse: collapse;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
thead {
  display: table-header-group;
}
.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}
ul.dashed {
  list-style-type: "-";
  margin: 0;
}
.underline {
  text-decoration: underline;
}
.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/KartaKwalifikacyjna.vue